import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"
import { ITomaFisica } from "../interfaces/erp/contabilidad/toma_fisica.interface"

export const useTableColumnsTomaFisica = () => {


  const columnsTomaFisica = useMemo<MRT_ColumnDef<ITomaFisica>[]>(() => [
    {
      accessorKey: 'codigo',
      header: 'codigo',
      Cell: ({ row }) => row.original?.codigo
    },
    {
      accessorKey: 'estado_solicitud',
      header: 'estado_solicitud',
    },
    {
      accessorKey: 'numero_referencia',
      header: 'numero_referencia',
    },
    {
      accessorKey: 'fecha_creacion',
      header: 'fecha_creacion',
    },
  ], [])



  return {
    columnsTomaFisica
  }

}